export default {
  getExcelCheckBoxesNames(state) {
    return state.ExcelCheckBoxesNames;
  },
};
